<div fxLayout="column" fxLayoutGap="30px">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px" class="app-dialog-background p-50">
        <div class="txt-h-18-7"
             [innerHTML]="'Contribution enhancement energy self-consumed electricity ({0})'|i18n: CACV_STRING">
        </div>
        <div class="txt-p-16-4"
             [innerHTML]="'Define to who the {0} should be allocated to, minus any portion of the {1} allocated to cover costs. '|i18n: CACV_STRING: CACV_STRING">
        </div>
        <mat-radio-group formControlName="cacvMode" fxLayout="column" fxLayoutGap="10px">
            <mat-radio-button app-radio-button *ngFor="let mode of cacvModes" [value]="mode" class="txt-p-14-4">
                {{ mode|radioCacvMode|i18n }}
            </mat-radio-button>
        </mat-radio-group>
    </form>
    <div fxLayout="row" fxLayoutAlign="center center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" generic-info class="txt-p-14-4">
            <app-icon name="fas-info-circle"></app-icon>
            <div>{{ '"Consumer utilities" are meant to be consumers and prosumers with respect to withdrawal activity only.'|i18n }}</div>
        </div>
    </div>
</div>
